/*
 * @Author: 陈朝晖
 * @Date: 2023-06-06 15:08:46
 * @LastEditTime: 2023-08-31 17:22:45
 * @Description:
 */
import config from "@/common/config.js";
import { cloneDeep, pick } from "lodash";

const state = {
  productInfo: {
    showWlImage: false,
  },
  images: [],
  mainVideo: {},
  detailVideo: {},
  image34List: [],
  // sourceData: {},
};

const getters = {};

const mutations = {
  setProductInfoV2(state, data) {
    state.productInfo = {
      productId: pick(data.global, "systemParam").systemParam?.id,
      global: pick(data, "global").global,
      subject: pick(data.data, "title").title.fields?.value,
      skuTable:
        pick(data.data, "skuTable").skuTable?.fields?.value ||
        pick(data.data, "processingSkuTable").processingSkuTable?.fields?.value ||
        [],
      showWlImage: pick(data.data, "primaryPicture").primaryPicture?.fields?.showWlImage ?? false,
    };
    state.images = (
      pick(data.data, "primaryPicture").primaryPicture?.fields?.value?.imageList ?? []
    )
      .slice(0, 5)
      .map((img) => img.url.replace(config.alicdn, ""));

    state.image34List = (
      pick(data.data, "primaryPicture").primaryPicture?.fields?.value?.image34List ?? []
    )
      .slice(0, 5)
      .map((img) => img.url.replace(config.alicdn, ""));
  },
  setProductInfoByKeyV2(state, { key, val }) {
    state.productInfo[key] = val;
  },
  clearProductInfoV2() {
    state.productInfo = {};
  },
  cleanSupplyInfoV2(state) {
    state.productInfo = {};
    // state.sourceData = {};
    state.images = [];
    state.mainVideo = {};
    state.detailVideo = {};
  },
  updateImagesV2(state, data) {
    state.images = data;
  },
  updateImage34V2(state, data) {
    state.image34List = data;
  },
  updateImagesByIndexV2(state, { index, url }) {
    state.images.splice(index, 1, url);
  },
  updateImages34ByIndexV2(state, { index, url }) {
    state.image34List.splice(index, 1, url);
  },
  spliceImagesV2(state, index) {
    state.images.splice(index, 1);
  },
  spliceImages34V2(state, index) {
    state.image34List.splice(index, 1);
  },
  setVideoV2(state, { mainVideo, detailVideo }) {
    if (mainVideo) {
      state.mainVideo = mainVideo;
    }
    if (detailVideo) {
      state.detailVideo = detailVideo;
    }
  },
  syncVideoV2(state) {
    if (state.mainVideo.videoUrl) {
      state.detailVideo = cloneDeep(state.mainVideo);
    }
  },
};

const actions = {
  setProductInfoAsyncV2({ commit }, data) {
    commit("setProductInfoV2", data);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
